import FAQPageLocationJpg from "./Images/FAQPageLocation.jpg";
import FAQPageLocationWebp from "./Images/FAQPageLocation.webp";

const FAQPageLocation = {jpg: FAQPageLocationJpg, webp: FAQPageLocationWebp, alt: "Frequently Asked Questions", w: "1000", h: "664"};

export {
    FAQPageLocation,
}